document
    .addEventListener("DOMContentLoaded", function () {

        const featured_timeline_div = document.getElementById("featured-time-line-id");
        const loader_div1 = document.getElementById("loader1");
        const loader_div2 = document.getElementById("loader2");
        const loader_div3 = document.getElementById("loader3");

        if (featured_timeline_div) {

            gsap.fromTo("#featured-time-line-section-container1 img", {
                opacity: 0,
                 onStart: () => {
                  loader_div1.style.display = "flex"; // Show loader
                }
            }, {
                opacity: 1,
                duration: 0.6,
                ease: "none",
                scrollTrigger: {
                    trigger: "#featured-time-line-section-container1",
                    start: "top 85%",
                    //markers:true
                }, 
                onComplete: () => {
                    loader_div1.style.display = "none"; // Hide loader
                  }
            });
            gsap.fromTo("#featured-time-line-section-container2 img", {
                opacity: 0,
                onStart: () => {
                  loader_div2.style.display = "flex"; // Show loader
                }
            }, {
                opacity: 1,
                duration: 0.6,
                ease: "none",
                scrollTrigger: {
                    trigger: "#featured-time-line-section-container2",
                    start: "top 85%",
                    //markers:true
                }, onComplete: () => {
                    loader_div2.style.display = "none"; // Hide loader
                  }
            });
            gsap.fromTo("#featured-time-line-section-container3 img", {
                opacity: 0,
               onStart: () => {
                  loader_div3.style.display = "flex"; // Show loader
                }
            }, {
                opacity: 1,
                duration: 0.6,
                ease: "none",
                scrollTrigger: {
                    trigger: "#featured-time-line-section-container3",
                    start: "top 85%",
                    //markers:true
                }, onComplete: () => {
                    loader_div3.style.display = "none"; // Hide loader
                  }
            });

            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: "#how-it-works-scale-img-container",
                    start: "top 80%",
                    //markers:true
                }
            });
            timeline.fromTo("#how-it-works-scale-img", {
                scale: 0.8
            }, {
                scale: 1,
                duration: 1
            }).fromTo("#how-it-works-scale-img-text", {
                opacity: 0,
                scale: 0.7,
                y: 50,
            }, {
                scale: 1,
                opacity: 1,
                y: 0,
                duration: 1,
                ease:"power3.inOut"
            }, "<");

            // GSAP timeline targeting dots with IDs 1dots to 7dots GSAP timeline targeting
            // dots with IDs 1dots to 7dots
            const tl = gsap.timeline({repeat: -1, yoyo: true});

            tl.fromTo("#dots4", {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.5
            }).fromTo("#dots5", {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.5
            }, "+=0.1").fromTo("#dots3", {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.5
            }, "<").fromTo("#dots6", {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.5
            }, "+=0.1").fromTo("#dots2", {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.5
            }, "<").fromTo("#dots7", {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.5
            }, "+=0.1").fromTo("#dots1", {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.5
            }, "<");
        }
    });